<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  <rect x="4" y="4" width="192" height="192" rx="36" fill="#000" stroke="url(#a)" stroke-width="8"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M149.3 62.8c-14.7 7.2-16.2 25.1-17.4 39.5-1.4 15.2-2.6 19.3-5.8 19.3-3.8 0-4.7-11.5-5.2-22.3-1-15.7-2.1-37.3-21.4-37.3C80.2 62 79 83.6 78.2 99.3c-.6 10.8-1.5 22.3-5.3 22.3-6.4 0-6.4-32.5-6.4-58.6v-.6H50v.6c0 46.8 0 75 22.9 75 19.7 0 20.9-21.8 21.7-37.8.4-7 1-21.8 4.9-21.8 3.6 0 4.4 12.8 4.8 21.2v.6c1 16 2.1 37.8 21.8 37.8 19.3 0 21-19.8 22.2-34.3v-.2c1-11.2 1.9-22.9 8.2-25.8l.5-.2-7.2-15-.5.3Z" fill="#fff"/>
  <defs>
    <linearGradient id="a" x1="-100" y1="100" x2="100" y2="300" gradientUnits="userSpaceOnUse">
      <stop stop-color="#CE55B0"/>
      <stop offset=".2" stop-color="#F34DAC"/>
      <stop offset=".3" stop-color="#F48E66"/>
      <stop offset=".4" stop-color="#F0B832"/>
      <stop offset=".6" stop-color="#B2CE37"/>
      <stop offset=".8" stop-color="#63D7AF"/>
      <stop offset=".9" stop-color="#1CC2DF"/>
      <stop offset="1" stop-color="#0580E6"/>
    </linearGradient>
  </defs>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcySwileGradient',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 200 200',
    },
  },
};
</script>

<style scoped>
  
</style>